exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":root {\n    --page-padding: 70px;\n    --content-padding: 5%;\n}\n\n.UlM8dibfzYdMHRBdShR3J {\n    padding-left: var(--page-padding);\n    padding-right: var(--page-padding);\n}\n", ""]);

// exports
exports.locals = {
	"root": "UlM8dibfzYdMHRBdShR3J"
};